module.exports = __webpack_public_path__ + "media/images/favicon/safari-pinned-tab-8bbafecd3f3cea0977cc3f2fe5981b6e.svg";